// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"4b8d0969","223":"42ad9517","433":"4b78f507","453":"113bb110","796":"f5739003"}[chunkId] + ".chunk.js";
};